"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_loading_skeleton_1 = __importDefault(require("react-loading-skeleton"));
const useGetPromo_1 = require("../../Hooks/useGetPromo");
const Types_1 = require("Types");
const VerticalImageTextBlock_1 = __importDefault(require("../Block/VerticalImageTextBlock/VerticalImageTextBlock"));
const style = __importStar(require("./styled"));
const Promo = ({ promoRef, setNewPromo, newPromo, linkFunction }) => {
    const { promo, isLoading } = (0, useGetPromo_1.useGetPromo)(promoRef && promoRef.toString());
    (0, react_1.useEffect)(() => {
        if (promo && promoRef) {
            setNewPromo(promo);
        }
        else {
            setNewPromo(null);
        }
    }, [promo, promoRef, setNewPromo]);
    if (!isLoading && newPromo) {
        return (react_1.default.createElement(VerticalImageTextBlock_1.default, { columns: 3, title: newPromo.title, textAlignment: Types_1.TextAlignment.LEFT, linkText: newPromo.link.title, link: { title: newPromo.link.title, href: newPromo.link.url }, desktopImage: newPromo.desktopImage ? newPromo.desktopImage : undefined, mobileImage: newPromo.mobileImage ? newPromo.mobileImage : undefined, isPromo: true, linkFunction: linkFunction }));
    }
    else {
        return (react_1.default.createElement(style.Col, { lg: 3 },
            react_1.default.createElement(react_loading_skeleton_1.default, { height: 180 }),
            react_1.default.createElement(style.StyledSkeleton, { width: "80%", height: 25 }),
            react_1.default.createElement(react_loading_skeleton_1.default, { width: "50%", height: 20 })));
    }
};
exports.default = Promo;
